<template>
    <div class="container">
        <scroll-wrap></scroll-wrap>
        <menu-list></menu-list>
        <div class="main" v-loading="loading">
            <div class="item-wrap">
                <div class="item" v-for="(item,index) in productList" :key="index">
                    <div class="mask-layer">
                        <i class="iconfont iconchakan"></i>
                        <span @click="selectProduct(item)">
                            选择模板
                        </span>
                    </div>
                    <div class="product-img">
                        <img :src="item.image" alt="">
                    </div>
                    <div class="product-attached">
                    <span v-for="(desImg,desImgIndex) in item.attachments" :key="desImgIndex">
                        <img :src="desImg" alt="" width="28px" height="28px" v-if="desImgIndex < 6">
                    </span>
                    </div>
                    <div class="product-price">
                        <span>${{item.price}}</span>
                    </div>
                    <div class="product-title">
                        {{item.title}}
                    </div>
                    <div class="product-comments">
                        <span>{{parseInt(Math.random()*(10000-8000)+8000)}}+ </span> comments
                    </div>
                    <div class="product-shop">
                        <span>
                            {{item.brand}}
                        </span>
                        <i class="iconfont iconownbrand"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="pagination-wrap">

        </div>
        <div class="foot">
            闽ICP备17025076号-2 <span style="margin: 0 20px"></span>©2017-{{new Date().getFullYear()}} All rights reserved.
        </div>
    </div>
</template>

<script>

    export default {
        name: "choose",
        components: {
        },
        data() {
            return {
                menu: [
                    {
                        name: '商品模板'
                    },
                    {
                        name: '商品优化'
                    },
                    {
                        name: '商品发布'
                    }
                ],
                productList: [],
                pagination: {
                    pageNo:1,
                    pageSize:9999
                },
                loading:true
            }
        },
        created() {
            this.axios.post('/student/shop/get').then(res=>{
                if(res.succeed && res.login){
                    if(!res.shop.hasComplete){
                        this.$router.push('/RegisterShop/initialize')
                    }
                }
            })
            this.axios.post('/login/current').then(res=>{
                if(res.login && res.succeed){
                    this.$store.commit('setData',{dataKey:'user',value:res.user})
                }
            })
            this.getData()
        },
        methods: {
            getData() {
                let params = {
                    pagination:{
                        pageNo:this.pagination.pageNo,
                        pageSize:this.pagination.pageSize
                    }
                }
                this.axios.post('/student/product/template/list', params).then(res => {
                    if (res.succeed) {
                        this.productList = res.items
                        this.pagination = res.pagination
                        this.loading = false
                    } else {
                        this.$message.error(res.message)
                    }
                })
            },
            selectProduct(item) {
                this.$store.commit('setData', {
                    dataKey: 'template',
                    value: {
                        default:{},
                        edit:{}
                    }
                });
                item.template = {id: item.id}
                item.id = null;
                this.$store.commit('setData', {
                    setKey: 'template.default',
                    value: item
                });
                this.$store.commit('setData', {
                    setKey: 'template.edit',
                    value: item
                });
                this.$router.push('/MaritimeSilkRoad/baseEdit')
            },
            handleSizeChange() {

            },
            handleCurrentChange(val) {
                this.pagination.pageNo = val;
                this.getData()
            }
        }
    }
</script>

<style scoped lang="scss">

    .main {
        min-height:300px;
        div.item-wrap {
            background: #FFFFFF;
            border-radius: 10px;
            box-shadow: 3px 10px 20px -6px #b5cdd3;
            margin-bottom: 28px;
            padding: 16px;
            display: inline-flex;
            flex-wrap: wrap;

            .item {
                width: 236px;
                height: 432px;
                box-sizing: border-box;
                padding: 8px;
                /*background: #f5f5f5;*/
                display: flex;
                flex-direction: column;
                position: relative;
                margin: 0 2px 2px 0;

                &:hover {
                    > div.mask-layer {
                        background: rgba(0, 0, 0, 0.3);
                        z-index: 1;
                        opacity: 1;
                        transition: all 0.3s linear;
                    }
                }

                div.mask-layer {
                    border-radius: 10px;
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: -1;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    transition: all 0.3s linear;
                    opacity: 0;

                    > i {
                        font-size: 70px;
                        color: #FFFFFF;
                        margin-bottom: 20px;
                    }

                    > span {
                        letter-spacing: 1px;
                        background: #FDAD53;
                        padding: 12px 26px;
                        border-radius: 10px;
                        color: #FFFFFF;
                        cursor: pointer;
                        margin-bottom: 80px;
                    }

                    &.active {
                        z-index: 1;
                        opacity: 1;
                        background: rgba(0, 0, 0, 0.8);
                    }
                }

                > .product-img {
                    width: 220px;
                    height: 220px;
                    overflow: hidden;

                    > img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }

                > .product-attached {
                    margin: 12px 0;
                    display: flex;
                    align-items: center;

                    > span {
                        margin-right: 8px;

                        &:last-child {
                            margin-right: 0;
                        }
                    }
                }

                > .product-price {
                    font-size: 22px;
                    margin: 0 0 10px 0;
                    color: #E50011;

                }

                > .product-title {

                    font-size: 13px;
                    color: #595757;
                    text-overflow: ellipsis;
                    line-height: 20px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    margin-bottom: 8px;
                }

                > .product-comments {
                    font-size: 13px;
                    line-height: 20px;
                    color: #adadad;
                    margin-bottom: 8px;

                    > span {

                        font-weight: bolder;
                        color: #089BAB;
                    }
                }

                > .product-shop {
                    display: flex;
                    align-items: center;

                    span {
                        font-size: 13px;
                        line-height: 20px;
                        color: #adadad;
                        max-width: 80%;
                        overflow: hidden;
                        height: 20px;
                    }

                    i {
                        margin-left: 8px;
                        font-size: 22px;
                        color: #089BAB;
                    }
                }

            }
        }
    }

    .pagination-wrap {
        display: inline-block;

        > div.pagination {
            padding: 0 20px;
            height: 60px;
            background: #FFFFFF;
            border-radius: 10px;
            box-shadow: 3px 10px 20px -6px #b5cdd3;
            display: flex;
            align-items: center;
            margin-bottom: 20px;
        }
    }

    div.foot {
        width: 100%;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 30px;
        font-size: 14px;
        color: #ABD5DB;
    }
</style>
